// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SectionHeader } from '@its-svp/svp-common-ui';
import SecurityCorrelationsHeaderNav from './SecurityCorrelationsHeaderNav';
import Button from '../common/Button';
// css
import '../../styles/components/correlations/SecurityCorrelationsHeader.scss';

export const SELECT_ALL = Symbol('SELECT_ALL');
export const CLEAR_ALL = Symbol('CLEAR_ALL');


class SecurityCorrelationsHeader extends Component {

  renderActionButtons() {
    const { onSelectEssentialCorrelations } = this.props;

    return (
      <div className='action-buttons-wrapper'>
        <Button
          onClick={onSelectEssentialCorrelations}
          primary
          label='Select SIEM Essentials'
        />
        <Button
          {...this.getSecondaryActionProps()}
        />
      </div>
    );
  }

  getSecondaryActionProps() {
    const {
      secondaryAction,
      onClearAllCorrelations,
      onSelectAllCorrelations
    } = this.props;

    return (
      secondaryAction === CLEAR_ALL ?
      {
        label: 'Clear All',
        onClick: onClearAllCorrelations
      } :
      {
        label: 'Select All',
        onClick: onSelectAllCorrelations
      }
    );
  }

  renderSectionHeader() {
    const {
      completedCategoriesCount,
      totalCategoriesCount
    } = this.props;

    return (
      <SectionHeader
        title='Key Goals: Security Correlations'
        caseCount={`${completedCategoriesCount}/${totalCategoriesCount} Sections Complete`}
        description='Identify security correlations that are critical for your organization by selecting YES or NO for each. This information will be correlated to data source types to help you plan your Splunk deployment.'
      />
    );
  }

  render() {
    const {
      baseNavRoute,
      canEditUsage,
      activeAreaIds,
      areas
    } = this.props;

    return (
      <div className='security-correlations-header'>
        <SecurityCorrelationsHeaderNav
          baseNavRoute={baseNavRoute}
          canEditUsage={canEditUsage}
          activeAreaIds={activeAreaIds}
          areas={areas}
        />
        {this.renderSectionHeader()}
        <div className='action-buttons'>
          {this.renderActionButtons()}
        </div>
      </div>
    );
  }
}

SecurityCorrelationsHeader.propTypes = {
  areas: PropTypes.array,
  area: PropTypes.object,
  activeAreaIds: PropTypes.array,
  canEditUsage: PropTypes.bool.isRequired,
  baseNavRoute: PropTypes.string.isRequired,
  completedCategoriesCount: PropTypes.number.isRequired,
  totalCategoriesCount: PropTypes.number.isRequired,
  onSelectEssentialCorrelations: PropTypes.func.isRequired,
  onSelectAllCorrelations: PropTypes.func.isRequired,
  onClearAllCorrelations: PropTypes.func.isRequired,
  secondaryAction: PropTypes.symbol.isRequired
};

export default SecurityCorrelationsHeader;



// WEBPACK FOOTER //
// ./src/components/correlations/SecurityCorrelationsHeader.js